// Configurações de ambiente
export interface Environment {
  name: string;
  apiBaseUrl: string;
  isDevelopment: boolean;
  isProduction: boolean;
}

// Detectar o ambiente baseado no Vite mode e variáveis de ambiente
const getEnvironment = (): Environment => {
  const isDev = import.meta.env.MODE === 'development';
  const isProd = import.meta.env.MODE === 'production';

  // Usar variável de ambiente ou fallback para as URLs padrão
  const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || 
    (isDev 
      ? 'http://localhost:5001/api'
      : 'https://portalchamadot4i-api-gec9hdfne0f5htcw.brazilsouth-01.azurewebsites.net/api'
    );

  return {
    name: import.meta.env.VITE_APP_ENV || import.meta.env.MODE,
    apiBaseUrl,
    isDevelopment: isDev,
    isProduction: isProd
  };
};

export const environment = getEnvironment();

// Helper para logs condicionais em desenvolvimento
export const devLog = (...args: any[]) => {
  if (environment.isDevelopment) {
    console.log('[DEV]', ...args);
  }
};

// Helper para warnings condicionais em desenvolvimento
export const devWarn = (...args: any[]) => {
  if (environment.isDevelopment) {
    console.warn('[DEV]', ...args);
  }
};

// Helper para errors em desenvolvimento
export const devError = (...args: any[]) => {
  if (environment.isDevelopment) {
    console.error('[DEV]', ...args);
  }
};